<div class="row">
  <!-- first widget -->
  <div
    class="col-12 col-md-3 relative"
    [ngClass]="templates[0].flushed ? 'flushed' : 'no-flush'"
    [ngSwitch]="templates[0].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="templates[0]" style="width: 100%"></cta>
    <image-block *ngSwitchCase="'image'" [imgblock]="templates[0]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="templates[0]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="templates[0]"
      [dynamic]="true"
      [slideCount]="2"
    ></showcase>
    <showcase
      *ngSwitchCase="'showcase-list'"
      [showcase]="templates[0]"
      [dynamic]="false"
      [slideCount]="2"
    ></showcase>
    <showcase
      *ngSwitchCase="'popular-list'"
      [showcase]="templates[0]"
      [dynamic]="false"
      [slideCount]="2"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="templates[0]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="templates[0]"></topic-search>

    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          title="Edit a Component"
          #select1
          class="form-control"
          (change)="openSideNav(select1.value, 0, templates, 'col-3-1-2-1', false)"
        >
          <option value="0">--Choose--</option>
          <option *ngFor="let comps of Components2" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <div *ngIf="edit && templates[0].typeOf !== 'edit'" class="edit-component text-center">
      <div class="edit-existing">
        <a
          tabindex="0"
          (click)="openSideNav(templates[0].typeOf, 0, templates, 'col-3-1-2-1', true)"
          (keyup.enter)="openSideNav(templates[0].typeOf, 0, templates, 'col-3-1-2-1', true)"
          >Edit Component</a
        >
        <div class="edit-or">- OR -</div>
        <select
          title="Choose a Component"
          #select1
          class="form-control"
          (change)="openSideNav(select1.value, 0, templates, 'col-3-1-2-1', false)"
        >
          <option value="0">--Choose New--</option>
          <option *ngFor="let comps of Components2" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <!-- second widget -->
  <div
    class="col-12 col-md-6 relative"
    [ngClass]="templates[1].flushed ? 'flushed' : 'no-flush'"
    style="margin-bottom: 10px"
    [ngSwitch]="templates[1].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="templates[1]" style="width: 100%"></cta>
    <image-block *ngSwitchCase="'image'" [imgblock]="templates[1]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="templates[1]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="templates[1]"
      [dynamic]="true"
      [slideCount]="5"
    ></showcase>
    <showcase
      *ngSwitchCase="'showcase-list'"
      [showcase]="templates[1]"
      [dynamic]="false"
      [slideCount]="5"
    ></showcase>
    <showcase
      *ngSwitchCase="'popular-list'"
      [showcase]="templates[1]"
      [dynamic]="false"
      [slideCount]="5"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="templates[1]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="templates[1]"></topic-search>
    <embed-url *ngSwitchCase="'embed'" [embed]="templates[1]"></embed-url>

    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          title="Edit a Component"
          #select2
          class="form-control"
          (change)="openSideNav(select2.value, 1, templates, 'col-3-1-2-1', false)"
        >
          <option value="0">--Choose--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <div *ngIf="edit && templates[1].typeOf !== 'edit'" class="edit-component text-center">
      <div class="edit-existing">
        <a
          tabindex="0"
          (click)="openSideNav(templates[1].typeOf, 1, templates, 'col-3-1-2-1', true)"
          (keyup.enter)="openSideNav(templates[1].typeOf, 1, templates, 'col-3-1-2-1', true)"
          >Edit Component</a
        >
        <div class="edit-or">- OR -</div>
        <select
          title="Choose a Component"
          #select2
          class="form-control"
          (change)="openSideNav(select2.value, 1, templates, 'col-3-1-2-1', false)"
        >
          <option value="0">--Choose New--</option>
          <option *ngFor="let comps of Components" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <!-- third wiget -->
  <div
    class="col-12 col-md-3 relative"
    [ngClass]="templates[2].flushed ? 'flushed' : 'no-flush'"
    style="margin-bottom: 10px"
    [ngSwitch]="templates[2].typeOf"
  >
    <cta *ngSwitchCase="'cta'" [cta]="templates[2]" style="width: 100%"></cta>
    <image-block *ngSwitchCase="'image'" [imgblock]="templates[2]"></image-block>
    <app-feedback *ngSwitchCase="'feedback'" [feed]="templates[2]"></app-feedback>
    <showcase
      *ngSwitchCase="'showcase'"
      [showcase]="templates[2]"
      [dynamic]="true"
      [slideCount]="2"
    ></showcase>
    <showcase
      *ngSwitchCase="'showcase-list'"
      [showcase]="templates[2]"
      [dynamic]="false"
      [slideCount]="2"
    ></showcase>
    <showcase
      *ngSwitchCase="'popular-list'"
      [showcase]="templates[2]"
      [dynamic]="false"
      [slideCount]="2"
    ></showcase>
    <text-block *ngSwitchCase="'text'" [textBlock]="templates[2]"></text-block>
    <topic-search *ngSwitchCase="'topic'" [topicSearch]="templates[2]"></topic-search>

    <ng-container *ngIf="edit">
      <div *ngSwitchCase="'edit'" class="choose-component">
        <select
          title="Edit a Component"
          #select3
          class="form-control"
          (change)="openSideNav(select3.value, 2, templates, 'col-3-1-2-1', false)"
        >
          <option value="0">--Choose--</option>
          <option *ngFor="let comps of Components2" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </ng-container>
    <div *ngSwitchDefault></div>

    <!-- CREATE A ROLLVER EDIT SECTION -->
    <div *ngIf="edit && templates[2].typeOf !== 'edit'" class="edit-component text-center">
      <div class="edit-existing">
        <a
          tabindex="0"
          (click)="openSideNav(templates[2].typeOf, 2, templates, 'col-3-1-2-1', true)"
          (keyup.enter)="openSideNav(templates[2].typeOf, 2, templates, 'col-3-1-2-1', true)"
          >Edit Component</a
        >
        <div class="edit-or">- OR -</div>
        <select
          title="Choose a Component"
          #select3
          class="form-control"
          (change)="openSideNav(select3.value, 2, templates, 'col-3-1-2-1', false)"
        >
          <option value="0">--Choose New--</option>
          <option *ngFor="let comps of Components2" [value]="comps.value" [title]="comps.height">
            {{ comps.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>
